// store.js
import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', () => {
    const message = ref();
    function setMessage(newMessage) {
        message.value = newMessage;
    }
    function clearMessage() {
        message.value = '';
    }
    // Bumped when a static QR code is created: the QR codes list reloads.
    const qrcodeCreated = ref(0);
    function notifyQrcodeCreated() {
        qrcodeCreated.value++;
    }

    return { message, setMessage, clearMessage, qrcodeCreated, notifyQrcodeCreated };
});
